import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { HEADER_STATES } from 'src/app/shared/header/header.helper';
import CT_TYPES from 'src/app/types/critical-thinking-types';
import { ChatMessage, SNE_INPUT_TYPES } from 'src/app/types/sne';
import { APP_COLORS } from 'src/global-styles';
import { SneCriticalThinkingBase } from '../sne-critical-thinking.base';


@Component({
  selector: 'ets-ct-multi-choice-schedule-map',
  templateUrl: './ct-multi-choice-schedule-map.component.html',
  styleUrls: ['./ct-multi-choice-schedule-map.component.scss']
})
export class CtMultiChoiceScheduleMapComponent extends SneCriticalThinkingBase implements OnInit {

  showModal = false;
  headerState: HEADER_STATES = HEADER_STATES.BACK;
  chatList: ChatMessage[] | undefined= [];

  APP_COLORS = APP_COLORS;
  SNE_INPUT_TYPES = SNE_INPUT_TYPES;

  toggleModal() {
    this.showModal=!this.showModal;
  }

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  multiResponseQuestionHandler(response: string) {
    let arrIndex = this.multiResponse.indexOf(response);
    if (arrIndex > -1) {
      // if answer is already in the array, remove it at arrIndex
      this.multiResponse.splice(arrIndex, 1);
    } else {
      this.multiResponse.push(response);
      this.multiResponse.sort();
    }
  }

  singleReponseQuestionHandler(questionIndex: number, answer: string) {
    if (answer) {
      this.multiResponse[questionIndex] = answer;
    }
  }


  additionalParamProcess() {
    console.log('Additional things happening here.');
  }
  

  ngOnInit(): void {
    this.processParams();
    if (this.ctType === CT_TYPES.ARGUMENTATION_1 ) {
      // if (this.questionData && this.questionData.socialMediaThread) {
      // }
      
    }

    this.chatList= this.questionData?.chatMessages;
    
  }
}
